module.exports = __webpack_public_path__ + "img/home.736c56fc.png";